<template>
  <p class="tw-m-0 dark--text tw-block"><slot /></p>
</template>

<script>
export default {
  name: "AtomText",
  props: ["text"]
};
</script>